import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CacheService } from './services/cache.service';
import { CacheInterceptor } from './services/cache.interceptor';

@NgModule({
  providers: [CacheService, { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true }],
})
export class CacheModule {}
